module.exports = __webpack_public_path__ + "static/media/mastercard.ae0915fe.png";